/**
 * Help Policies Block — tabs + accordion interactivity.
 * Mirrors faqs.js but scoped to .block-help-policies.
 */
export const HelpPolicies = {
	init() {
		document.querySelectorAll( '.block-help-policies' ).forEach( ( block ) => {
			if ( block.dataset.helpPoliciesReady === '1' ) {
				return;
			}
			block.dataset.helpPoliciesReady = '1';

			const tabs   = block.querySelectorAll( '[data-policy-tab]' );
			const panels = block.querySelectorAll( '[data-policy-panel]' );

			tabs.forEach( ( tab ) => {
				tab.addEventListener( 'click', () => {
					const idx = tab.getAttribute( 'data-policy-tab' );
					tabs.forEach( ( t )   => { t.classList.toggle( 'is-active', t === tab ); t.setAttribute( 'aria-selected', t === tab ? 'true' : 'false' ); } );
					panels.forEach( ( p ) => p.classList.toggle( 'is-active', p.getAttribute( 'data-policy-panel' ) === idx ) );
				} );
			} );

			block.querySelectorAll( '[data-policy-item]' ).forEach( ( item ) => {
				const head = item.querySelector( '.block-help-policies__item-head' );
				if ( ! head ) return;
				head.addEventListener( 'click', () => {
					const open = item.classList.toggle( 'is-open' );
					head.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
				} );
			} );
		} );
	},
};
